export const environment = {
  production: true,
  API_ENDPOINT: 'https://v12.thawani.om/api/v1/',
  IMAGE_BASE_URL: 'https://business.thawani.om',
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyC6G7WDhdoVNeNGrQE5x-BOQsqRyEQ25hk",
    authDomain: "v12-prod.firebaseapp.com",
    databaseURL: "https://v12-prod.firebaseio.com",
    projectId: "v12-prod",
    storageBucket: "v12-prod.appspot.com",
    messagingSenderId: "336302963847",
    appId: "1:336302963847:web:f1516ab5619edf12cb0c22",
    measurementId: "G-X0KGD80J9F"
  },
  VERSION: '2.2.1'
};
